export default [
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#444444' }]
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry',
    stylers: [{ color: '#757575' }, { weight: '1.7' }]
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry',
    stylers: [{ weight: '1.5' }, { color: '#757575' }]
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [{ saturation: '-80' }]
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [{ saturation: '-70' }]
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{ visibility: 'on' }, { lightness: '0' }]
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{ visibility: 'on' }, { lightness: '0' }, { saturation: '-70' }]
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ saturation: '-60' }]
  },
  {
    featureType: 'poi.business',
    elementType: 'all',
    stylers: [{ visibility: 'on' }, { saturation: '-70' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#ffffff' }]
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{ saturation: '-100' }]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#ff6b00' }, { lightness: '45' }, { saturation: '-24' }]
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{ visibility: 'on' }, { saturation: '-55' }, { lightness: '-5' }, { gamma: '1' }]
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [{ color: '#4a95cc' }, { visibility: 'on' }]
  }
];
